<template>
  <div class="block-form">
    <q-input
      outlined
      type="textarea"
      :model-value="block.text"
      label="Texto"
      rows="3"
      @update:model-value="emit('update', { ...block, text: String($event ?? '') })"
    />
    <q-input
      outlined
      :model-value="block.attribution"
      label="Atribución (opcional)"
      @update:model-value="emit('update', { ...block, attribution: String($event ?? '') })"
    />
  </div>
</template>

<script setup lang="ts">
interface QuoteBlock {
  type: 'quote';
  text: string;
  attribution?: string;
}

const props = defineProps<{ block: QuoteBlock }>();
const emit = defineEmits<{ (e: 'update', block: QuoteBlock): void }>();

void props;
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
</style>
